export const de = {
  nav_experiences: "Experiences",
  nav_destinations: "Destinations",
  nav_boat: "Capri & die Inseln",
  nav_taste: "Genuss",
  nav_stay: "Übernachten",
  nav_create: "Erlebnis gestalten",
  nav_book: "Erlebnis buchen",
  sign_in: "Anmelden",
  sign_out: "Abmelden",
  account_greeting: "Hallo",
  tagline: "Entdecke Kampanien. Erlebe es wirklich.",
  hero_line1: "Erlebe das Land, wo das Mittelmeer ",
  hero_line2: "auf Feuer trifft.",
  hero_cta1: "Erlebnisse entdecken",
  hero_cta2: "Tour personalisieren",
  dim_title: "Was möchtest du erleben?",
  dim_sea: "MEER",
  dim_sea_desc: "Meer, Inseln, Boote, Kanus, Küsten und Sonnenuntergänge.",
  dim_culture: "KULTUR",
  dim_culture_desc: "Archäologie, Geschichte, Kunst, Dörfer und Kulturerbe.",
  dim_nature: "NATUR",
  dim_nature_desc: "Vulkane, Berge, Wanderwege und Outdoor-Aktivitäten.",
  dim_taste: "GENUSS",
  dim_taste_desc: "Wein, Küche, lokale Produkte und kulinarische Traditionen.",
  explore_title: "Kampanien entdecken",
  explore_sub: "Von den Phlegräischen Feldern nach Neapel, von den Inseln zum Vesuv, von der Küste in den Apennin.",
  featured_title: "Ausgewählte Erlebnisse",
  featured_sub: "Die beliebtesten Erlebnisse, kuratiert von unserem Team.",
  bysea_title: "Flegrea by Sea",
  bysea_sub: "Kampanien aus einer anderen Perspektive sehen.",
  bysea_cta: "Bootserlebnisse entdecken",
  taste_title: "Taste Campania",
  taste_sub: "Eine Reise durch die Aromen Kampaniens.",
  taste_cta: "Genuss-Erlebnisse entdecken",
  beyond_title: "Beyond the Coast",
  beyond_sub: "Entdecke die wilde Seite Kampaniens.",
  beyond_cta: "Naturerlebnisse entdecken",
  create_title: "Du findest nicht, was du suchst?",
  create_sub: "Wir gestalten dein Erlebnis gemeinsam: private Touren, Familien, Paare, Gruppen, Firmen, romantische Anträge, Genuss und Meer.",
  create_cta: "Tour erstellen",
  stay_title: "Stay With Us",
  stay_sub: "Ausgewählte B&Bs und Residenzen: die ideale Basis, um das Land zu erleben.",
  stay_cta: "Unterkünfte entdecken",
  why_title: "Warum Flegrea Experience?",
  why_1: "Wir kennen das Land jenseits der Reiseführer",
  why_2: "Authentische Erlebnisse, nicht nur Besuche",
  why_3: "Kleine Gruppen: mehr Zeit, mehr Aufmerksamkeit",
  why_4: "Flexibilität: wir passen das Erlebnis an dich an",
  why_5: "Wir arbeiten mit lokalen Partnern und Profis",
  stories_title: "Ein Land, das erzählt werden will",
  stories_sub: "Mythen, Eruptionen und Kaiser: Geschichten der Phlegräischen Felder, erzählt von denen, die hier leben.",
  final_title: "Deine Kampanien-Geschichte beginnt hier",
  final_sub: "Wähle ein Erlebnis, füge hinzu, was du liebst — oder lass es uns für dich gestalten.",
  copy_1: "Kampanien ist mehr als ein Reiseziel.",
  copy_2: "Es ist antike Städte, vulkanische Landschaften, Mittelmeerinseln, verborgene Dörfer, Bergpfade, außergewöhnliches Essen und Geschichten, die Jahrhunderte überlebt haben.",
  copy_3: "Flegrea Experience wurde geschaffen, damit du all das erleben kannst.",
  copy_4: "Von den Phlegräischen Feldern nach Neapel, von Procida und Ischia nach Pompeji, von der Amalfiküste bis zu den Bergen an der Grenze zu den Abruzzen und Molise.",
  copy_5: "Wähle ein Erlebnis. Füge hinzu, was du liebst. Oder lass es uns für dich gestalten.",
  copy_cta: "Kampanien entdecken",
  exp_page_title: "Erlebnisse",
  exp_page_sub: "Kuratierte Erlebnisse in ganz Kampanien. Wähle deins — oder kombiniere es mit unseren Genuss-Add-ons.",
  filter_all: "Alle",
  filter_culture: "Kultur & Geschichte",
  filter_sea: "Meer & Inseln",
  filter_canoe: "Kanu & Wasser",
  filter_nature: "Natur & Outdoor",
  filter_food: "Essen",
  filter_wine: "Wein",
  filter_night: "Abends",
  filter_private: "Privat",
  offer_badge: "-10%",
  launch_offer: "Einführungsangebot — voller Preis gestrichen",
  all_destinations: "Alle Reiseziele",
  results: "Erlebnisse",
  from: "ab",
  per_person: "pro Person",
  price_note: "Richtpreise, bei Buchung zu bestätigen.",
  discover: "Erlebnis entdecken",
  the_experience: "Das Erlebnis",
  highlights: "Highlights",
  included: "Inklusive",
  not_included: "Nicht inklusive",
  addons_title: "Make It Taste Better",
  addons_sub: "Füge deinem Erlebnis eine kulinarische Note Kampaniens hinzu.",
  addons_price_each: "pro Person",
  on_request: "Auf Anfrage",
  meet_guide: "Dein Guide",
  meet_guide_text: "Jedes Erlebnis wird von zertifizierten Guides und lokalen Profis geführt, die von Flegrea Experience ausgewählt wurden. Wissen macht den Unterschied.",
  good_to_know: "Gut zu wissen",
  gtk_1: "Outdoor-Aktivitäten unterliegen Wetter- und Seebedingungen.",
  gtk_2: "Treffpunkt und Logistik werden nach der Buchung mitgeteilt.",
  gtk_3: "Private Erlebnisse können auf Anfrage individuell angepasst werden.",
  faq_title: "FAQ",
  faq_q1: "In welchen Sprachen sind die Erlebnisse verfügbar?",
  faq_a1: "Alle Erlebnisse sind auf Italienisch und Englisch verfügbar. Weitere Sprachen auf Anfrage.",
  faq_q2: "Wie funktioniert die Buchung?",
  faq_a2: "Kontaktiere uns per WhatsApp oder Formular: Wir bestätigen Verfügbarkeit und Details und reservieren dein Erlebnis. In dieser Phase ist keine Online-Zahlung erforderlich.",
  faq_q3: "Kann ich ein Erlebnis anpassen?",
  faq_a3: "Ja. Jedes Erlebnis kann mit Genuss-Add-ons, Transfers und Extras erweitert oder mit 'Erlebnis gestalten' von Grund auf neu gebaut werden.",
  book_now: "Jetzt buchen",
  request_quote: "Angebot anfordern",
  duration: "Dauer",
  group_size: "Teilnehmer",
  location_label: "Ort",
  languages_label: "Sprachen",
  starting_price: "Startpreis",
  dest_page_title: "Reiseziele",
  dest_page_sub: "Kampanien nach Gebieten geordnet: Wähle wohin, dann wie du es erlebst.",
  dest_experiences: "Erlebnisse an diesem Reiseziel",
  view_destination: "Entdecken",
  boat_page_sub: "Kampanien aus einer anderen Perspektive sehen.",
  boat_departure: "Abfahrt",
  whats_included: "Inklusive",
  book_boat: "Buche dein Erlebnis auf dem Meer",
  taste_page_sub: "Eine Reise durch die Aromen Kampaniens.",
  make_taste: "Make It Taste Better",
  make_taste_sub: "Füge deinem Erlebnis eine kulinarische Note Kampaniens hinzu. Fast jedes Erlebnis lässt sich um einen Genussmoment erweitern.",
  territories_title: "Genussregionen",
  stay_page_sub: "Nicht einfach Hotels: ideale Basen, um das Land zu erleben — mit Erlebnissen vor der Tür.",
  check_availability: "Verfügbarkeit prüfen",
  rooms_label: "Zimmer",
  services_label: "Ausstattung",
  nearby_exp: "Erlebnisse in der Nähe",
  stay_placeholder_note: "Ausgewählte Unterkunft — Details und Verfügbarkeit in Vorbereitung.",
  step1: "Mit wem reist du?",
  step2: "Wie viele?",
  step3: "Wann?",
  step4: "Was liebst du?",
  step5: "Wo?",
  step6: "Etwas Besonderes dazu?",
  step7: "Erzähl uns mehr",
  step8: "Kontakt",
  opt_solo: "Allein",
  opt_couple: "Paar",
  opt_family: "Familie",
  opt_friends: "Freunde",
  opt_group: "Gruppe",
  more_than_10: "Mehr als 10 (individuelle Anfrage)",
  next: "Weiter",
  back: "Zurück",
  submit: "Mein Erlebnis erstellen",
  thankyou: "Danke. Dein Kampanien-Erlebnis beginnt hier.",
  thankyou_sub: "Wir haben deine Anfrage erhalten und melden uns in Kürze, um dein Erlebnis zu gestalten.",
  thankyou_wa: "Schneller per WhatsApp",
  name_label: "Name",
  email_label: "E-Mail",
  phone_label: "Telefon",
  whatsapp_label: "WhatsApp",
  notes_placeholder: "Erzähl uns, wovon du träumst: besondere Anlässe, Tempo, Must-sees, besondere Bedürfnisse...",
  footer_experiences: "Erlebnisse",
  footer_legal: "Rechtliches",
  footer_contacts: "Kontakt",
  footer_follow: "Folge uns",
  privacy: "Datenschutz",
  cookie: "Cookies",
  terms: "AGB",
  wa_float: "Erlebnis planen",
  wa_message: "Hallo Flegrea Experience! Ich hätte gern Informationen zu:",
  wa_book_prefix: "Hallo! Ich möchte das Erlebnis buchen:",
  wa_quote_prefix: "Hallo! Ich hätte gern ein Angebot für:",
  wa_stay_prefix: "Hallo! Ich möchte die Verfügbarkeit prüfen für:",
  badge_PRIVATE: "Privat",
  badge_SMALL_GROUP: "Kleingruppe",
  badge_SUMMER: "Sommer",
  badge_BOAT: "Boot",
  badge_FOOD: "Genuss",
  badge_NATURE: "Natur",
  loading: "Laden...",
  not_found: "Erlebnis nicht gefunden",
  back_experiences: "Alle Erlebnisse",
  back_destinations: "Alle Reiseziele",
  about: "Über uns",
  contact: "Kontakt",
  faq: "FAQ",
  nature_word: "Natur",
  step_of: "von",
  date_flexible: "Meine Daten sind flexibel",
  map_hint: "Erkunde die Karte — fahre mit der Maus über die Orte",
  choose_date: "Datum",
  participants: "Teilnehmer",
  time_slot: "Zeitfenster",
  slot_morning: "Vormittag",
  slot_afternoon: "Nachmittag",
  slot_evening: "Abend",
  addons_label: "Zusatzleistungen",
  estimated_total: "Geschätzte Summe",
  send_request: "Buchungsanfrage senden",
  whatsapp_context: "Per WhatsApp buchen",
  ask_questions: "Fragen? Schreib uns",
  save_experience: "Erlebnis speichern",
  saved_favorite: "Erlebnis gespeichert",
  removed_favorite: "Aus Gespeicherten entfernt",
  login_to_save: "Melde dich an, um Erlebnisse zu speichern",
  request_sent: "Anfrage gesendet",
  request_sent_sub: "Wir haben deine Anfrage erhalten und melden uns in Kürze, um Verfügbarkeit und Details zu bestätigen.",
  remove: "Entfernen",
  account_title: "Mein Konto",
  account_signin_sub: "Melde dich an, um deine Anfragen und gespeicherten Erlebnisse zu sehen.",
  my_requests: "Meine Anfragen",
  my_experiences: "Meine Erlebnisse",
  no_requests: "Du hast noch keine Anfragen gesendet.",
  no_favorites: "Du hast noch keine Erlebnisse gespeichert.",
  discover_experiences: "Erlebnisse entdecken",
  custom_request: "Individuelle Anfrage",
  requested_on: "Angefragt am",
  status_inviata: "Anfrage gesendet",
  status_attesa: "Bestätigung ausstehend",
  status_confermata: "Bestätigt",
  status_completata: "Abgeschlossen",
  status_annullata: "Storniert",
  cookie_banner_text: "Wir verwenden notwendige technische Cookies und — nur mit deiner Einwilligung — Analyse-Cookies, um das Erlebnis zu verbessern. Du kannst deine Wahl jederzeit ändern.",
  cookie_accept_all: "Alle akzeptieren",
  cookie_reject: "Ablehnen",
  cookie_customize: "Anpassen",
  cookie_save_prefs: "Auswahl speichern",
  cookie_necessary: "Notwendige Cookies (immer aktiv)",
  cookie_analytics: "Analyse-Cookies",
  manage_cookies: "Cookie-Einstellungen verwalten",
  search_placeholder: "Erlebnis oder Ort suchen…",
  related_title: "Das könnte dir auch gefallen",
  what_to_bring: "Was mitbringen",
  wtb_1: "Bequeme Schuhe und eine Wasserflasche",
  wtb_2: "Badesachen, Handtuch und Sonnencreme für Erlebnisse am Meer",
  wtb_3: "Zwiebellook für Trekking und Berge",
  boat_hero_note: "Private Ausfahrten • Sonnenuntergang • Aperitivo • Individuelle Erlebnisse",
  boat_hero_sub2: "Das Meer von Neapel aus einer völlig anderen Perspektive erleben.",
  discover_experience: "Erlebnis entdecken",
  faq_page_title: "Häufige Fragen",
  faq_page_sub: "Buchungen, Zahlungen, Stornierungen, Wetter und alles Wissenswerte.",
  need_help: "Brauchst du Hilfe?",
  booking_info: "Buchungsinformationen",
  cancellation_policy: "Stornobedingungen",
  all_faqs: "Alle FAQs",
  admin_title: "Admin-Bereich",
  admin_denied: "Eingeschränkter Zugang. Melde dich mit einem Admin-Konto an.",
  admin_link: "Admin-Panel",
  tab_overview: "Übersicht",
  tab_requests: "Anfragen",
  tab_experiences: "Erlebnisse",
  tab_users: "Nutzer",
  tab_contacts: "Kontakte",
  stats_requests: "Anfragen gesamt",
  stats_users: "Registrierte Nutzer",
  stats_experiences: "Aktive Erlebnisse",
  stats_favorites: "Speicherungen",
  change_status: "Status ändern",
  featured_label: "Hervorgehoben",
  save_label: "Speichern",
  saved_ok: "Gespeichert",
  price_edit: "Preis (ab)",
  day_title: "Gestalte deinen Tag in Kampanien",
  day_sub: "Wähle, was du erleben willst: Wir kombinieren automatisch Meer, Kultur, Genuss und Natur zu einem maßgeschneiderten Tag.",
  day_pick: "Was willst du erleben?",
  day_area: "Wo willst du sein?",
  day_area_all: "Überall in Kampanien",
  day_people: "Wie viele?",
  day_generate: "Meine Reiseroute erstellen",
  day_itinerary: "Deine Reiseroute",
  day_morning: "Vormittag",
  day_afternoon: "Nachmittag",
  day_evening: "Abend",
  day_empty: "Wähle mindestens zwei Dimensionen, um die Route zu erstellen.",
  day_send: "Diese Route anfragen",
  day_sent_title: "Route angefragt",
  day_sent_sub: "Wir haben deine Wunschroute erhalten und machen daraus ein konkretes Angebot.",
  day_per_person: "pro Person",
  day_edit: "Auswahl ändern",
  nav_companion: "Companion",
  companion_title: "Flegrea Companion",
  companion_sub: "Dein Reisebegleiter: Lesungen und Geschichten zu den Orten, die du besuchst — und deine Services immer griffbereit mit Unterstützung unseres Teams.",
  langs_note: "bald verfügbar",
  readings_title: "Lesungen & Vertiefungen",
  min_read: "Min. Lesezeit",
  back_companion: "Alle Geschichten",
  your_services: "Deine Services",
  support_staff: "Team-Support",
  support_title: "Brauchst du eine Hand?",
  support_sub: "Verwalte alles selbst — und wenn nötig, ist unser Team eine Nachricht entfernt.",
  carousel_overline: "Das Land",
  carousel_title: "Kampanien, wirklich",
  carousel_sub: "Echte Fotografien von unseren Touren. Demnächst: Drohnenaufnahmen der archäologischen Stätten und Bootsausflüge.",
  contact_title: "Informationen anfragen",
  contact_sub: "Einfach, schnell, präzise: Schreib uns und wir antworten direkt per E-Mail.",
  message_label: "Deine Nachricht",
  send_message: "Anfrage senden",
  contact_sent: "Nachricht gesendet",
  contact_sent_sub: "Danke! Wir antworten in Kürze an die angegebene E-Mail-Adresse.",
  contact_required: "Bitte Name, E-Mail und Nachricht ausfüllen.",
  contact_error: "Senden fehlgeschlagen. Bitte erneut versuchen oder per WhatsApp schreiben.",
  contact_privacy_note: "Mit dem Senden akzeptierst du die Datenschutzerklärung. Die Nachricht geht direkt an info@flegreaexperience.com.",
  pay_online: "Online zahlen",
  pay_online_note: "Sichere Zahlung mit Stripe. Verfügbarkeit vorbehaltlich Bestätigung.",
  payment_processing: "Zahlung wird geprüft…",
  payment_success_title: "Zahlung erfolgreich",
  payment_success_sub: "Danke! Deine Anfrage ist zahlungsseitig bestätigt. Wir kontaktieren dich, um Verfügbarkeit und Details zu bestätigen.",
  payment_success_pending_note: "Wenn du die Zahlung abgeschlossen hast, kann die Bestätigung einige Minuten dauern. Bei Fragen schreib uns per WhatsApp.",
  payment_check_again: "Prüfung läuft",
  payment_cancel_title: "Zahlung abgebrochen",
  payment_cancel_sub: "Es wurde nichts abgebucht. Du kannst es jederzeit erneut versuchen oder die Anfrage ohne Online-Zahlung senden.",
  nav_all_experiences: "Alle Erlebnisse",
  nav_gallery: "Galerie",
  gallery_title: "Galerie",
  gallery_sub: "Alle Orte unserer Erlebnisse, Bild für Bild: von den Vulkanen der Phlegräischen Felder bis zu den Inseln, vom unterirdischen Neapel bis zu den Zitronen Sorrents.",
  gallery_videos_title: "Das Land in Bewegung",
  gallery_videos_sub: "Aufnahmen vom Meer und vom Land. Neue Videos — Drohne und Erlebnisgeschichten — folgen in Kürze.",
  gallery_coming_soon: "In Kürze",
  gallery_photos_title: "Alle Fotos",
  back_home: "Zur Startseite",
  hero_sub: "Touren, Ausflüge, Meer, Geschichte und authentische Aromen in den Phlegräischen Feldern.",
  story_cta: "Geschichte entdecken",
  seo_home_title: "Flegrea Experience — Touren & Erlebnisse in den Phlegräischen Feldern",
  seo_home_desc: "Authentische Erlebnisse in den Phlegräischen Feldern: geführte Touren in Pozzuoli, Baia und Bacoli, Avernus-See und Monte Nuovo, Bootsausflüge nach Capri, Ischia und Procida.",
  boat_cta_title: "Bereit zum Ablegen?",
  boat_cta_sub: "Schreib uns auf WhatsApp und wir planen deinen Tag auf dem Meer in den Phlegräischen Feldern.",
};
